exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multi-select-item-title {\n  width: 28rem !important;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n", ""]);

// exports
